var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun-edit-3792632",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.622,
    height: 18.168,
    viewBox: "0 0 18.622 18.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3625",
    "data-name": "Path 3625",
    d: "M136.347,56a1.371,1.371,0,0,0-.972.4l-7.842,7.841-.021.021a1.344,1.344,0,0,0-.348.568,5.477,5.477,0,0,0-.348,2.817.7.7,0,0,0,.553.553,5.087,5.087,0,0,0,2.044-.1,4.954,4.954,0,0,0,.766-.248,1.369,1.369,0,0,0,.568-.355c.009-.009.013-.012.021-.021l7.849-7.841a1.568,1.568,0,0,0-.128-2.207l-.908-.908A1.777,1.777,0,0,0,136.5,56c-.05,0-.1,0-.149,0Zm-.007,1.362s.111-.045.277.121c.3.305.609.607.915.908.166.166.116.281.121.277l-.454.454-1.306-1.313Zm-1.412,1.412,1.306,1.313L129.819,66.5c.014-.022-.069.049-.17.092a3.686,3.686,0,0,1-.553.177,4.367,4.367,0,0,1-.965.106,4.351,4.351,0,0,1,.106-.958,3.725,3.725,0,0,1,.185-.561c.033-.077.061-.123.064-.135Zm-12.263.4a2.281,2.281,0,0,0-2.271,2.271V71.9a2.281,2.281,0,0,0,2.271,2.271h10.446a2.281,2.281,0,0,0,2.271-2.271V65.312a.681.681,0,1,0-1.363,0V71.9a.892.892,0,0,1-.908.908H122.665a.892.892,0,0,1-.908-.908V61.452a.892.892,0,0,1,.908-.908h7.494a.681.681,0,1,0,0-1.362Z",
    transform: "translate(-120.394 -56)",
    fill: "#f37321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.10d0a3d55a5f9cc334cf5b619cdb1b6a.svg";
export { ForwardRef as ReactComponent };